export default "/images/CCTs.svg?d0f1ad40e679e2462b4ba1d306f122b9";